import React, { useState } from "react";
import Navbar from "./components/navbar/navbar";
import NavbarMobile from "./components/navbar/navbar-mobile";
import "./App.scss";
import { Breakpoint, BreakpointProvider } from "react-socks";
import { BrowserRouter } from "react-router-dom";
import { Route } from "react-router-dom";
import BlogHome from "./components/blog/blog-home";
import PortfolioComponent from "./components/portfolio/portfolio-component";

function App() {
  const [sideDrawerOpen, onSideDrawerOpen] = useState(true);
  return (
    <BreakpointProvider>
      <Breakpoint medium up>
        <Navbar />
      </Breakpoint>

      <Breakpoint small down>
        <NavbarMobile onSideDrawerOpen={onSideDrawerOpen} />
      </Breakpoint>

      <BrowserRouter>
        <Route
          exact
          path="/"
          render={(props) => (
            <PortfolioComponent {...props} sideDrawerOpen={sideDrawerOpen} />
          )}
        />
        <Route path="/blogs" render={BlogHome} />
      </BrowserRouter>
    </BreakpointProvider>
  );
}

export default App;
